import editor from "./editor";
import commonHelpers from "common/plugins/issues/topic_present_with_monetary_value";
import reasonViewer from "./reason_viewer";

export default {
  ...commonHelpers,
  editor,
  ...reasonViewer,
};
